export default "__VITE_ASSET__BFYrD_8w__"